<template>
  <footer :class="{ 'footer--home': $route.path === '/' }">
    <div class="footer">
      <div class="entry">
        <ul>
          <li>
            <ul>
              <li class="list">
                <p>用户登录</p>
                <p @click="toHref(1,'about')">救援机构</p>
                <p @click="toHref(2,'about')">监管机构</p>
                <p @click="toHref(3,'about')">指挥中心</p>
              </li>
              <li class="list">
                <p>关于</p>
                <p @click="toHref(4,'about')">公司简介</p>
                <p @click="toHref(5,'news')">新闻中心</p>
                <p @click="toHref(6)">合作咨询</p>
              </li>
              <li class="list">
                <p>联系</p>
                <p @click="toHref(7)">意见反馈</p>
                <p>客服热线：+86-10-83423665</p>
                <p>指挥中心：+86-10-83423665</p>
              </li>
            </ul>
          </li>
          <li>
            <ul>
              <li v-if="showMobileTools">
                <div class="erweima" style="float:left;margin-left:55px;"><h4>下载大救星</h4><img src="./img/appgzh.png" alt="" ></div>
              </li>
              <li>
                <div class="erweima" style="float:right"><h4>微信公众号</h4><img src="./img/wxgzh.png" alt=""></div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      
      
    </div>
    <p class="copyright">大救星版权所有@2018-2026 <a href="http://beian.miit.gov.cn/" target="_blank">备案号：京ICP备2025140282号-1</a></p>
    <!-- 备案号：京ICP备2025140282号 -->
  </footer>
</template>
<script type="text/javascript">
import util from '@/util/util.js'
export default {
  data () {
    return {
      showMobileTools: util.config.showMobileTools,
      url:util.config.url
    }
  },
  methods: {
    toHref (id,item) {
      if (id == 1 || id == 2 || id == 3) {
        window.location.href = this.url + "/djxwork/#/";
      } else if (id == 4 || id == 5) {
        this.$router.push({
          path: '/aboutus',
          query:{
            activeName:item
          }
        })
        this.$root.bus.$emit('only', 5)
        this.$root.bus.$emit('about', item)
      } else if (id == 6) {
        window.location.href = this.url + "/djxwork/#/contact";
      } else if (id == 7) {
        window.location.href = this.url + "/djxwork/#/feedback";
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  footer{
    width: 100%;
    background: #F8F8F8;
    .footer{
      padding: 4vw 17vw 3.5vw;
      overflow: hidden;
      .entry{
        ul{
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          flex-wrap: nowrap;
          align-items: center;
          font-family:PingFang;
          color: #333333;
          font-size:1vw;
          font-weight: bold;
          .list{
            margin-right: 5vw;
            p{
              margin-bottom: 1.5vw;
              font-size: 0.8vw;
              font-weight: normal;
              color: #666;
              cursor: pointer;
              a{
                color: #666;
              }
              &:hover{
                color: #00ABFA;
              }
            }
            p:first-child{
              font-size: 1vw;
              font-weight: 600;
              color: #333;
              margin-bottom: 1.7vw;
            }
            &:last-child{
              p:nth-child(3),p:nth-child(4):hover{
                color: #666;
              }
            }
          }
        }
      }
      .erweima{
        margin-left: 5vw;
          h4{
            font-family:PingFang;
            color: #333333;
            font-size:1vw;
            text-align: center;
            font-weight: normal;
          }
          img{
            width:8vw;
            margin-top: 1.5vw;
          }
        }
    }
    .copyright{
      width: 100%;
      color: #333;
      font-size: 20px;;
      border-top: 1px solid #050001;
      line-height: 50px;
      text-align: center;
      clear: both;
    }
  }
  /* 首页页脚与正文使用相同的 15vw 留白，避免底部信息另起一条对齐线。 */
  footer.footer--home .footer {
    padding-left: 15vw;
    padding-right: 15vw;
  }
</style>



// WEBPACK FOOTER //
// src/components/indexFooter.vue